import { event } from '@zillow/universal-analytics';
export var sendSellerShowcaseInteractionEvent = function sendSellerShowcaseInteractionEvent(source, zpid) {
  var propertyContextualBlock = {
    zpid: parseInt(zpid, 10)
  };
  event(buildSellerShowcaseInteractionEvent(source, propertyContextualBlock));
};
export function buildSellerShowcaseInteractionEvent(triggerSource, propertyContextualBlock, overrides) {
  return Object.assign({
    envelope: buildEnvelope('4', '6684', '2'),
    clickstream_trigger: buildTrigger('interaction', 'seller_showcase|landing_page', 'no_trigger_object', triggerSource),
    semantic: buildSemantic('seller_showcase_interaction', ['showcase', 'dtc'])
  }, propertyContextualBlock !== null ? {
    property_info: propertyContextualBlock
  } : {}, overrides);
}
/**
 * Builds the envelope block for a Universal Analytics event.
 * @param templateId The event template ID.
 * @param typeId The event type ID.
 * @param typeVersionId The event type version ID.
 * @returns An object with the envelope block properties.
 */

function buildEnvelope(templateId, typeId, typeVersionId) {
  return {
    event_template_id: templateId,
    event_template_version_id: '1',
    event_type_id: typeId,
    event_type_version_id: typeVersionId,
    event_client_start_dtm: new Date().toISOString()
  };
}
/**
 * Builds the clickstream_trigger block for a Universal Analytics event.
 * @param triggerType The type of the trigger. e.g. 'interaction'
 * @param triggerLocation The location of the trigger. e.g. 'seller_showcase|landing_page'
 * @param triggerObject The object of the trigger. e.g. 'no_trigger_object'
 * @param triggerSource The source of the trigger. e.g. 'button_to_lead_form'
 * @returns An object with the clickstream_trigger block properties.
 */


function buildTrigger(triggerType, triggerLocation, triggerObject, triggerSource) {
  return {
    trigger_location_nm: triggerLocation,
    trigger_type_nm: triggerType,
    trigger_object_nm: triggerObject,
    trigger_source_nm: triggerSource
  };
}
/**
 * Builds the semantic block for a Universal Analytics event.
 * @param semanticEvent The semantic event name. e.g. 'showcase_dtc_interaction'
 * @param topicTags The topic tags for the event. e.g. ['showcase', 'dtc']
 * @returns An object with the semantic block properties.
 */


export function buildSemantic(semanticEvent, topicTags) {
  return {
    semantic_event_nm: semanticEvent,
    topic_tag_txt: topicTags
  };
}
//# sourceMappingURL=analytics.js.map